// eyeq — MobileEyeQ (MEQ) delivery metadata contract.
// GENERATED from EyeQ/mobile_eyeq.schema (5).json — the canonical format the client
// ingests. These enums are the SINGLE SOURCE OF TRUTH for taxonomy + geo values;
// the D1 taxonomy/quota seeds store these exact spellings. NOTE: category &
// sub_category use the "and" spelling here (e.g. "Clothing and Accessories"); the
// source Taxonomy.xlsx / quota matrix use "&" — bridged at seed time, pinned by test.
import { z } from 'zod';

export const MEQ_CATEGORIES = [
  "Household Items",
  "Furniture",
  "Electronics and Devices",
  "Tools and Hardware",
  "Clothing and Accessories",
  "Sports and Fitness",
  "Toys and Games",
  "Stationery and Office",
  "Food and Beverage",
  "Musical Instruments",
  "Transportation",
  "Medical and Personal Care",
  "Books and Media",
  "Religious and Cultural",
  "Outdoor and Garden",
  "Environmental and Natural Elements",
  "Containers and Storage",
  "Safety and Security",
  "Crafts and Hobbies",
  "Pets and Animals",
  "Fine Art and Museum",
  "Business and Storefronts",
  "Bathroom Items",
  "Baby and Child Care",
  "Lighting and Electrical",
  "Signs, Symbols and Icons",
  "Laundry and Cleaning",
  "Eyewear",
  "Shopping and Retail",
  "Time and Measurement",
  "Uncommon/Rare Objects",
  "Text and Documents",
  "Other",
  "Uncommon_Rare Objects",
] as const;

export const MEQ_SUBCATEGORIES = [
  "Kitchen Essentials",
  "Tableware",
  "Food Storage",
  "Food Preparation",
  "Small Appliances",
  "Cleaning Supplies",
  "Home Decor",
  "Textiles",
  "Seating",
  "Tables",
  "Storage",
  "Beds",
  "Outdoor Furniture",
  "Personal Devices",
  "Computing",
  "Home Entertainment",
  "Photography and Video",
  "Wearable Tech",
  "Climate Control",
  "Hand Tools",
  "Power Tools",
  "Fasteners and Materials",
  "Garden Tools",
  "Measuring Tools",
  "Building Materials",
  "Footwear",
  "Bags and Luggage",
  "Headwear",
  "Accessories",
  "Outerwear",
  "Ball Sports Equipment",
  "Fitness Equipment",
  "Racquet Sports",
  "Protective Gear",
  "Water Sports",
  "Children's Toys",
  "Board and Card Games",
  "Outdoor Toys",
  "Educational Toys",
  "Video Games",
  "Writing Instruments",
  "Paper Products",
  "Desk Accessories",
  "Art Supplies",
  "Binding and Filing",
  "Writing Surfaces",
  "Office Equipment",
  "Packaged Foods",
  "Fresh Produce",
  "Beverages, Drinks and Cocktails",
  "Baked Goods, Bread and Desserts",
  "Condiments and Spices",
  "Drinkware",
  "Cooked Food and Prepared Dishes",
  "String Instruments",
  "Percussion",
  "Wind Instruments",
  "Keyboard Instruments",
  "Personal Mobility",
  "Motor Vehicles",
  "Vehicle Parts",
  "Travel Accessories",
  "Regional Vehicles",
  "First Aid",
  "Personal Hygiene",
  "Beauty and Cosmetics",
  "Wellness",
  "Mobility Aids",
  "Books",
  "Physical Media",
  "Reading Accessories",
  "Religious Items",
  "Traditional Items",
  "Festival and Holiday",
  "Party Supplies",
  "Planters and Pots",
  "Plants",
  "Outdoor Lighting",
  "Weather Gear",
  "Sky and Atmospheric",
  "Water Bodies",
  "Landforms and Terrain",
  "Vegetation and Flora",
  "Weather Elements",
  "Celestial and Light",
  "Natural Textures",
  "Bottles and Jars",
  "Boxes",
  "Baskets",
  "Bins and Waste",
  "Fire Safety",
  "Security",
  "Emergency Supplies",
  "Protective Eyewear",
  "Sewing and Textiles",
  "Modeling and Building",
  "Art Creation",
  "Dogs",
  "Cats",
  "Other Pets",
  "Pet Accessories",
  "Pet Care Products",
  "Wild Birds",
  "Wild Mammals",
  "Insects and Arthropods",
  "Marine Life",
  "Wild Reptiles and Amphibians",
  "Farm Animals",
  "Zoo and Exotic Animals",
  "Paintings",
  "Sculptures - Small",
  "Sculptures - Medium",
  "Sculptures - Large",
  "Mixed Media Art",
  "Historical Artifacts",
  "Public Art and Street Art",
  "Cultural Exhibits",
  "Natural History",
  "Museum Placards",
  "Exhibition Posters and Information",
  "Gallery Windows",
  "Gallery Signage",
  "Celebrity and Public Figure Posters",
  "Retail Stores",
  "Food and Dining",
  "Services",
  "Healthcare",
  "Entertainment and Leisure",
  "Hospitality",
  "Professional Services",
  "Automotive",
  "Bath Accessories",
  "Toiletries",
  "Baby Products",
  "Child Safety",
  "Nursery Items",
  "Light Fixtures",
  "Bulbs and Components",
  "Electrical Items",
  "Traffic and Road Signs",
  "Business and Commercial Signs",
  "Public Information and Wayfinding Signs",
  "Safety and Warning Symbols",
  "Environmental and Recycling Symbols",
  "Food and Dietary Symbols",
  "Technology and Interface Icons",
  "Sports and Activity Symbols",
  "Currency and Payment Symbols",
  "Weather and Temperature Symbols",
  "Religious and Cultural Symbols",
  "Care and Maintenance Symbols",
  "Transportation and Transit Symbols",
  "Advertisements and Promotional Displays",
  "Event Signage and Information",
  "Laundry Items",
  "Cleaning Products",
  "Vision Correction",
  "Shopping Items",
  "Postal and Shipping",
  "Clocks and Timers",
  "Weather Instruments",
  "Antiques",
  "Scientific Instruments",
  "Professional Equipment",
  "Collectibles",
  "Instructions and Manuals",
  "Lists and Inventories",
  "Book Pages and Text Content",
  "Educational Content and Classroom Materials",
  "Forms and Templates",
  "Labels, Tags and Package Text",
  "Menus and Directories",
  "Notices and Announcements",
  "Promotional Materials and Sale Information",
  "Receipts and Invoices",
  "Schedules, Timetables and Itineraries",
  "Reference Pages",
  "Certificates and Official Documents",
  "Credentials and Access Information",
  "Other",
] as const;

export const MEQ_COUNTRIES = [
  "Australia",
  "Austria",
  "Brazil",
  "Bulgaria",
  "Canada",
  "Chile",
  "China",
  "Colombia",
  "Croatia",
  "Czech Republic",
  "Denmark",
  "Egypt",
  "Finland",
  "France",
  "Germany",
  "Greece",
  "Hong Kong",
  "India",
  "Indonesia",
  "Ireland",
  "Israel",
  "Italy",
  "Japan",
  "Kenya",
  "Malaysia",
  "Mexico",
  "Morocco",
  "Netherlands",
  "New Zealand",
  "Philippines",
  "Poland",
  "Portugal",
  "Romania",
  "Saudi Arabia",
  "Singapore",
  "South Africa",
  "South Korea",
  "Spain",
  "Sweden",
  "Switzerland",
  "Taiwan",
  "Thailand",
  "Turkey",
  "UAE",
  "United Kingdom",
  "United States",
  "Vietnam",
  "Belgium",
  "Norway",
] as const;

export const MEQ_LANGUAGES = [
  "ar_AE",
  "ar_EG",
  "ar_MA",
  "ar_SA",
  "bg_BG",
  "cs_CZ",
  "da_DK",
  "de_AT",
  "de_CH",
  "de_DE",
  "el_GR",
  "en_AU",
  "en_CA",
  "en_GB",
  "en_IE",
  "en_IN",
  "en_KE",
  "en_NZ",
  "en_US",
  "en_ZA",
  "es_CL",
  "es_CO",
  "es_ES",
  "es_MX",
  "fi_FI",
  "fil_PH",
  "fr_CA",
  "fr_CH",
  "fr_FR",
  "fr_MA",
  "he_IL",
  "hi_IN",
  "hr_HR",
  "id_ID",
  "it_CH",
  "it_IT",
  "ja_JP",
  "ko_KR",
  "ms_MY",
  "nl_NL",
  "pl_PL",
  "pt_BR",
  "pt_PT",
  "ro_RO",
  "sv_SE",
  "sw_KE",
  "th_TH",
  "tr_TR",
  "vi_VN",
  "zh_CN",
  "zh_HK",
  "zh_SG",
  "zh_TW",
  "en_SG",
  "es_US",
  "fr_BE",
  "zh_XC",
  "nb_NO",
  "nl_BE",
  "hi_Latn_IN",
] as const;

export const MeqCategorySchema = z.enum(MEQ_CATEGORIES);
export type MeqCategory = z.infer<typeof MeqCategorySchema>;
export const MeqSubCategorySchema = z.enum(MEQ_SUBCATEGORIES);
export type MeqSubCategory = z.infer<typeof MeqSubCategorySchema>;
export const MeqCountrySchema = z.enum(MEQ_COUNTRIES);
export type MeqCountry = z.infer<typeof MeqCountrySchema>;
export const MeqLanguageSchema = z.enum(MEQ_LANGUAGES);
export type MeqLanguage = z.infer<typeof MeqLanguageSchema>;

export const MeqIndoorOutdoorSchema = z.enum(["indoor", "outdoor"]);
export const MeqIndoorLightingSchema = z.enum(["Bright Artificial Light", "Dim Artificial Light", "Natural Daylight", "Mixed Lighting", "NA"]);
export const MeqOutdoorLightingSchema = z.enum(["Night", "Twilight", "Soft Daylight", "Bright Daylight"]);

// place_details: the 2026-08-11 Labeling Guide made it FREE TEXT ("Kitchen,
// Supermarket, Public Park"), superseding the structured string this contract
// enforced since 2026-07-31. The structured helpers stay for callers that
// still build the old form (it is valid free text), but the schema no longer
// rejects a plain place word — the accepted 2026-08-11 deliveries shipped
// "Museum" / "Zoo" / "Street" and the client's own template shows the same.
export const MEQ_PLACE_TYPES_INDOOR = [
  "Kitchen", "Living Room", "Bedroom", "Bathroom", "Office", "Gym", "Mall",
  "Store", "Restaurant", "Cafe", "Library", "Hospital", "School",
  "Tourist Place", "Warehouse", "Garage", "Other",
] as const;
export const MEQ_PLACE_TYPES_OUTDOOR = [
  "Park", "Street", "Garden", "Beach", "Forest", "Mountain", "Playground",
  "Parking Lot", "Sports Field", "Market", "Sidewalk", "Bridge",
  "Tourist Place", "Rooftop", "Other",
] as const;

/** Canonical string for the delivery column. Indoor carries the lighting as the
 *  third segment (the protocol's own example does), outdoor stops at the type. */
export function eyeqBuildPlaceDetails(
  indoorOutdoor: "indoor" | "outdoor", placeType: string, indoorLighting: string,
): string {
  return indoorOutdoor === "indoor"
    ? `Indoor - ${placeType} - ${indoorLighting}`
    : `Outdoor - ${placeType}`;
}

/** null | 'place_format'. Checked against the row's own indoor_outdoor so an
 *  "Outdoor - …" string on an indoor frame is a violation, not a pass. */
export function eyeqPlaceDetailsNote(
  placeDetails: string, indoorOutdoor: string, indoorLighting: string,
): string | null {
  const parts = placeDetails.split(" - ");
  if (indoorOutdoor === "indoor") {
    if (parts.length !== 3) return "place_format";
    if (parts[0] !== "Indoor") return "place_format";
    if (!(MEQ_PLACE_TYPES_INDOOR as readonly string[]).includes(parts[1])) return "place_format";
    if (parts[2] !== indoorLighting) return "place_format";
    return null;
  }
  if (parts.length !== 2) return "place_format";
  if (parts[0] !== "Outdoor") return "place_format";
  if (!(MEQ_PLACE_TYPES_OUTDOOR as readonly string[]).includes(parts[1])) return "place_format";
  return null;
}

// The 15 required delivery fields (+ url conditional) per Capture Protocol Table 1.
// All free-text metadata is ENGLISH ONLY (protocol). Snapped from the schema:
// every field NOT NULL ⇒ z.string().min(1) where minLength:1, else z.string().
export const MeqAssetMetaSchema = z.object({
  subject_name: z.string().min(1),
  disambiguation_details: z.string().min(1),
  category: MeqCategorySchema,
  sub_category: MeqSubCategorySchema,
  indoor_outdoor: MeqIndoorOutdoorSchema,
  indoor_lighting: MeqIndoorLightingSchema,
  outdoor_lighting: MeqOutdoorLightingSchema,
  place_details: z.string().min(1),
  has_text: z.boolean(),
  city: z.string(),
  country: MeqCountrySchema,
  language: MeqLanguageSchema,
  camera_make: z.string(),
  camera_model: z.string(),
  filename: z.string().min(1),
  url: z.string().nullable().optional(), // required-when-applicable per taxonomy url flag
});
export type MeqAssetMeta = z.infer<typeof MeqAssetMetaSchema>;
